import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private http: HttpClient, public api: LoginService) { }
  GetTokens() {
    return new HttpHeaders({
      'Token': this.api.CheckandGetToken()
    });
  }
  GetSalesMAEN(LocationID, TimeZone, UserID, SDate, EDate) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/salesmaen/` + LocationID + '/' + TimeZone + '/' + UserID + '/' + SDate + '/' + EDate, { headers: this.GetTokens() });
  }

  GetSalesPaymentType(LocationID, TimeZone, UserID, SDate, EDate) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/salespaymenttype/` + LocationID + '/' + TimeZone + '/' + UserID + '/' + SDate + '/' + EDate, { headers: this.GetTokens() });
  }
  GetLiveOrders(LocationID, TimeZone, UserID, SDate, EDate) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/salespaymenttype/` + LocationID + '/' + TimeZone + '/' + UserID + '/' + SDate + '/' + EDate, { headers: this.GetTokens() });
  }
  GetVisitors(TimeZone, UserID, SDate, EDate) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/visitorslocationwise/` + TimeZone + '/' + UserID + '/' + SDate + '/' + EDate, { headers: this.GetTokens() });
  }
  GetCONR(LocationID, TimeZone, UserID, SDate, EDate) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/conr/` + LocationID + '/' + TimeZone + '/' + UserID + '/' + SDate + '/' + EDate, { headers: this.GetTokens() });
  }
  GetTopItems(LocationID, TimeZone, UserID, SDate, EDate) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/topitem/` + LocationID + '/' + TimeZone + '/' + UserID + '/' + SDate + '/' + EDate, { headers: this.GetTokens() });
  }
  SaleLocationGraph(TimeZone, UserID) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/salesgraph/` + TimeZone + '/' + UserID, { headers: this.GetTokens() });
  }
  GetALLlocations(UserID) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/locations/` + UserID, { headers: this.GetTokens() });
  }
  GetStockNotification(LocationID) {
    return this.http.get<any[]>(environment.rootUrl + `/api/dashboard/stocknotification/` + LocationID, { headers: this.GetTokens() });
  }

}
